import { HttpClient, HttpErrorResponse, HttpResponse, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, Subject, Observable, catchError, map, of, tap } from "rxjs";
import { environment } from '../../environments/environment';
import { UserModel,  JwTokenModel, ArkUserType, ClientViewModel, ClientModel } from "../core/api/models";
import { ClientsApiService  } from '../core/api/services';
import { Utils } from "../core/utils";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root',
})
export class ClientService {

  clientsApiService = inject(ClientsApiService);
  
  public currentClient$: Subject<ClientModel | null> = new Subject<ClientModel | null>();
  public currentClient: ClientModel | null = null;

  public activeClients$: Subject<ClientViewModel[] | null> = new Subject<ClientViewModel[] | null>();
  public activeClients: ClientViewModel[] | null = null;

  constructor(private http: HttpClient, private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer) {

    const currentClientData = localStorage.getItem('currentClient');
    if (currentClientData) {
      this.currentClient = JSON.parse(currentClientData) as ClientModel;
      console.debug('Client Info', this.currentClient.BusinessName);
      this.currentClient$.next(this.currentClient);
    } else {
      this.currentClient$.next(null);
    } 


    this.currentClient$.subscribe(x => {
      console.debug('currentClient$', x);
      if (x) {
        localStorage.setItem('currentClient', JSON.stringify(x));
      }
      else {
        localStorage.removeItem('currentClient');
      }
      this.currentClient = x;
    });

    this.activeClients$.subscribe(x => {
      console.debug('activeClients$', x);
    });


  }


  
  public getCurrentClient() {
    if (this.currentClient) {
      return of(this.currentClient);
    }
    return this.currentClient$.asObservable();
  }

  private _gettingClientInfo = false;
  public getClientInfo(clientID: number): Observable<ClientModel | null> {


    this._gettingClientInfo = true;
    return this.clientsApiService.Get( {  body: {id: clientID} })

      .pipe(tap(
        (result) => {
          this._gettingClientInfo = false;
          this.currentClient$.next(result);
        },
        (err) => {
          this._gettingClientInfo = false;
          this.currentClient$.next(null);
          return of(null);
        }));
  }
  
  public getActiveClients() : Observable<ClientViewModel[] | null> {
    if (this.activeClients) {
      return of(this.activeClients);
    }

    return this.clientsApiService.List( {  body: {
          filters: {Active: [{Value: true, MatchMode: 'contains', Operator: 'and'}]},
sortOrder: -1,
sortField: 'OpenTickets',

first: 0,
rows: 100
} })

      .pipe(
        map((result) => result.Result || null),
        tap((result) => {
          this.activeClients$.next(result);
        }),
        catchError(() => {
          this.activeClients$.next(null);
          return of(null);
        })
      );


  }


  public getClientLogo(client: ClientViewModel | ClientModel | null, type: string = 'Print'): any {
    if (!client) {
      return null;
    }

    var siteName = client.SiteName?.toLocaleLowerCase();

    if (environment.production)
      return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/${type}Logo/${siteName}.png`);

    if (siteName == 'optodev' || siteName == 'beta')
      return 'https://beta.optomiser-development.com/Login/PrintLogo/beta.png';

    return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.optomiser.com/Login/${type}Logo/${siteName}.png`);
  }

  

  public getClientURL(client: ClientViewModel | ClientModel | null, application: string = ''): any {
    if (!client) {
      return null;
    }

    var siteName = client.SiteName?.toLocaleLowerCase();

    if (!environment.production && siteName == 'optodev')
        siteName = 'beta'
      
    if (application=='')
      return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}`);
    else
      return this.sanitizer.bypassSecurityTrustUrl(`https://${application}-${siteName}.${environment.baseDomain}`);

  }
  

}
